module.exports = __webpack_public_path__ + "static/Coinspot-1d3d857cfa2e96584e7eb70f6db97d7a.png";